import { Record } from 'immutable';

const StudentOnlineHomeworkRecord = Record({
  accuracy: undefined,
  completion: undefined,
  sessionId: undefined,
  studentId: undefined,
});

class StudentOnlineHomework extends StudentOnlineHomeworkRecord { }

export default StudentOnlineHomework;



// WEBPACK FOOTER //
// ./data/OnlineHomework/StudentOnlineHomework/model.js